import { BaseTextFieldProps, FormControl, InputBaseProps } from "@mui/material"
import FormikInput from "common/bit/form/FormikInput"
import styled from "styled-components"

const Styled = {
  FormControl: styled(FormControl)``,
  FieldWrapper: styled.div<{ $marginTop: number }>`
    margin-top: ${(p) => {
      if (p?.$marginTop === 0) return "0px"
      if (p?.$marginTop) return p.$marginTop + "px"
      return "22px"
    }};
  `,
}
// type options for autoComplete
type AutoCompleteOptions =
  | "name"
  | "tel-national"
  | "tel-local"
  | "tel-local-prefix"
  | "email"
  | "honorific-prefix"
  | "given-name"
  | "additional-name"
  | "family-name"
  | "honorific-suffix"
  | "nickname"
  | "username"
  | "new-password"
  | "current-password"
  | "one-time-code"
  | "organization-title"
  | "organization"
  | "street-address"
  | "address-line1"
  | "address-line2"
  | "address-line3"
  | "address-level4"
  | "address-level3"
  | "address-level2"
  | "address-level1"
  | "country"
  | "country-name"
  | "postal-code"
  | "cc-name"
  | "cc-given-name"
  | "cc-additional-name"
  | "cc-family-name"
  | "cc-number"
  | "cc-exp"
  | "cc-exp-month"
  | "cc-exp-year"
  | "cc-csc"
  | "cc-type"
  | "transaction-currency"
  | "transaction-amount"
  | "language"
  | "bday"
  | "bday-day"
  | "bday-month"
  | "bday-year"
  | "sex"
  | "url"
  | "photo"
  | "one-time-code"
  | ""

export interface CommonInputProps extends BaseTextFieldProps {
  name: string
  label: string
  type?: "text" | "email" | "tel" | "number" | "date"
  required?: boolean
  maxLength?: number
  placeholder?: string
  numericKeyBoard?: boolean
  InputProps?: InputBaseProps
  // bottomText?: string
  centerField?: boolean
  autoFocus?: boolean
  autoComplete?: AutoCompleteOptions
  className?: string
  hideLabel?: boolean
  marginTop?: number
}

const FormInput = ({
  name,
  label,
  type = "text",
  required = false,
  placeholder,
  maxLength,
  numericKeyBoard,
  InputProps,
  // bottomText,
  centerField,
  autoFocus,
  className,
  hideLabel,
  marginTop,
  ...props
}: CommonInputProps) => (
  <FormControl>
    <Styled.FieldWrapper $marginTop={marginTop ?? 22}>
      <FormikInput
        name={name}
        label={label}
        type={numericKeyBoard ? "tel" : type}
        required={required}
        placeholder={placeholder}
        maxLength={maxLength}
        numeric={numericKeyBoard}
        centerField={centerField}
        InputProps={InputProps}
        autoFocus={autoFocus}
        className={className}
        hideLabel={hideLabel}
        {...props}
      />
    </Styled.FieldWrapper>
  </FormControl>
)

export default FormInput
